import Pagination from "./Pagination";
import {
    GridPagination,
  } from "@mui/x-data-grid";


export default function CustomPagination(props) {
    return <GridPagination ActionsComponent={Pagination} {...props} />;
  }